module.exports = __webpack_public_path__ + "img/united-nations.43fd3c32.png";